import {
  parseAsArrayOf,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
  parseAsFloat,
} from "nuqs";

import {
  bankSearchParam,
  filterSearchParam,
  modalitySearchParam,
  paymentSearchParam,
  sortingSearchParam,
  typeSearchParam,
} from "@/filters";
import { defaultSortingCriteria, defaultTypeCriteria } from "@/constants";

const arraySeparator = ",";

export const useFilter = () =>
  useQueryStates(
    {
      [filterSearchParam.cidade]: parseAsArrayOf(
        parseAsString,
        arraySeparator
      ).withDefault([]),
      [filterSearchParam.ordenar]: parseAsStringLiteral(
        sortingSearchParam
      ).withDefault(defaultSortingCriteria),
      [filterSearchParam.tipo]:
        parseAsStringLiteral(typeSearchParam).withDefault(defaultTypeCriteria),
      [filterSearchParam.pagamento]: parseAsArrayOf(
        parseAsStringLiteral(paymentSearchParam),
        arraySeparator
      ).withDefault([]),
      [filterSearchParam.modalidade]: parseAsArrayOf(
        parseAsStringLiteral(modalitySearchParam),
        arraySeparator
      ).withDefault([]),
      [filterSearchParam.banco]: parseAsArrayOf(
        parseAsStringLiteral(bankSearchParam),
        arraySeparator
      ).withDefault([]),
      [filterSearchParam.precoMax]: parseAsFloat,
      [filterSearchParam.precoMin]: parseAsFloat,
      [filterSearchParam.tamanhoPropriedade]: parseAsFloat,
      [filterSearchParam.tamanhoArea]: parseAsFloat,
      [filterSearchParam.pesquisa]: parseAsString.withDefault(""),
    },
    {
      clearOnDefault: true,
    }
  );
